"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getters = void 0;
var getters = {
  selectedTruck: function selectedTruck(state) {
    return state.selectedTruck;
  },
  planDateRange: function planDateRange(state) {
    return state.planDateRange;
  },
  tableLoading: function tableLoading(state) {
    return state.tableLoading;
  },
  plan: function plan(state) {
    return state.plan;
  },
  anyChanges: function anyChanges(state) {
    return state.anyChanges;
  },
  isPlanExists: function isPlanExists(state) {
    return state.isPlanExists;
  },
  truckFilters: function truckFilters(state) {
    return state.truckFilters;
  },
  trucks: function trucks(state) {
    return state.trucks;
  },
  truckLoading: function truckLoading(state) {
    return state.truckLoading;
  },
  selectedProjects: function selectedProjects(state) {
    return state.selectedProjects;
  },
  selectedCustomers: function selectedCustomers(state) {
    return state.selectedCustomers;
  },
  selectedTrucks: function selectedTrucks(state) {
    return state.selectedTrucks;
  }
};
exports.getters = getters;